<script>
    import Header from "../components/Header.svelte";

    import Button, { Label } from '@smui/button/styled';
    import Textfield from '@smui/textfield/styled';
    import Icon from '@smui/textfield/icon/styled';
    import HelperText from '@smui/textfield/helper-text/index';
    import CharacterCounter from '@smui/textfield/character-counter/index';
    import CreditCard from "svelte-credit-cards";

    import {api_host} from "../stores.js";
    import {doAPIPost} from '../utils/Fetching.svelte';

    import {querystring} from 'svelte-spa-router'

    import * as yup from 'yup';    
    import Payment from "payment";

    import { toast } from '@zerodevx/svelte-toast'


    // let your_name = "";
    // let your_email = "";

    // let recipient_name = "";
    // let recipient_email = "";

    // let gift_amount = "";
    let message = "";

    // let cc_number = ""; 
    // let cc_name = "";
    // let cc_cvc = ""; 
    // let cc_expiry = "";

    let focused_field = "number";
    function setcvcfocus(){focused_field = "cvc";}
    function setnumberfocus(){focused_field = "number";}


    const formSchema = yup.object().shape({
        your_name: yup
            .string()
            .required('Name is Required'),
        your_email: yup
            .string()
            .required('This Field is Required')
            .email('Invalid email'),
        recipient_name: yup
            .string()
            .required('Name is Required'),
        recipient_email: yup
            .string()
            .required('This Field is Required')
            .email('Invalid email'),
        gift_amount: yup
            .string()
            .matches(
                /([0-9]+)\.([0-9]{2})/,
                'Not a valid amount. Example: 50.00'
            ),
        cc_name: yup
            .string()
            .required('This must match the name on your card.'),
        cc_number: yup
            .string()
            .required('This must match the number on your card.')
            .test('cc-is-good', 'Card number is invalid.', value => Payment.fns.validateCardNumber(value)),
        cc_expiry: yup
            .string()
            .required('Expiration date is required')
            .max(5, 'Not a valid expiration date. Example: MM/YY')
            .matches(
                /([0-9]{2})\/([0-9]{2})/,
                'Not a valid expiration date. Example: MM/YY'
            )
            .test('expiry-is-good', 'Expiration date is invalid.', value => Payment.fns.validateCardExpiry(value)),
        cc_cvc: yup
            .string()
            .required('This is a 3 or 4 digit number.')
            .min(3, 'Must be at least 3 digits.')
            .max(4, 'Must be a 3 or 4 digit number.')
            .matches(
                /^[0-9]{3,4}$/,
                'Code must be a 3 or 4 digit number.'
            ),
    });    

    function process_gift(gift_query_string) {

        const params = new URLSearchParams(gift_query_string)

        if(params.has('value') === true) {
                field_data.gift_amount = params.get('value');
        }

    }

    $: {
        if('cc_expiry' in field_data && field_data.cc_expiry !== undefined && field_data.cc_expiry.length > 2) {
            // console.log("formatting expiry");
            let tmp_expiry = field_data.cc_expiry.replace(/\D/g,'');
            if(tmp_expiry.length > 1) {
                tmp_expiry = tmp_expiry.slice(0, 2) + "/" + tmp_expiry.slice(2);
            }
            if(tmp_expiry.length > 5){
                tmp_expiry = tmp_expiry.substring(0, 5)
            }
            field_data.cc_expiry = tmp_expiry;
        }
    }

    let field_data = {};
    for (let nk in formSchema.describe().fields){
        field_data[nk] = "";
        field_data[`${nk}_iv`] = false;
        field_data[`${nk}_h`] = "";
    }

    function resetFieldData() {
        for (let nk in formSchema.describe().fields){
            field_data[`${nk}_iv`] = false;
            field_data[`${nk}_h`] = "";
        }
    }

    async function validateForm() {
        resetFieldData();
        let res = true;
        for (let nk in formSchema.describe().fields){
            await formSchema.validateAt(nk, field_data, {
                abortEarly: true  
            }).catch((err) => {
                field_data[`${nk}_iv`] = true;
                field_data[`${nk}_h`] = err.errors[0];
                res = false;
            });
        }
        return res;
    }

    async function validateSingle(nk) {
        const validateAtRes = await formSchema.validateAt(nk, field_data, {
            abortEarly: true  
        }).then(() => {
            field_data[`${nk}_iv`] = false;
            field_data[`${nk}_h`] = '';
        }).catch((err) => {
            console.log(err);
            field_data[`${nk}_iv`] = true;
            field_data[`${nk}_h`] = err.errors[0];
        });
    }

    $: sent_gift = process_gift($querystring)

    let disable_send = false;

    async function send_gift_card() {
        if(await validateForm()) {
            disable_send = true;
            const turl = api_host + "/api/gift_cards";
            const payload = {
                your_name: field_data.your_name, 
                your_email: field_data.your_email, 
                recipient_name: field_data.recipient_name, 
                recipient_email: field_data.recipient_email, 
                gift_amount: field_data.gift_amount.toString(),
                message: message};
            const headers = {'Content-Type': 'application/json', "Cc-Info": JSON.stringify({
                cc_name: field_data.cc_name, 
                cc_number: field_data.cc_number, 
                cc_cvc: field_data.cc_cvc, 
                cc_expiry: field_data.cc_expiry})};

            // console.log(turl);
            // console.log(payload);
            // console.log(headers);

            let res = await doAPIPost(turl, "Sending your gift card ...", "Gift card sent successfully! Check your email for receipt.", payload, headers, 10000);
            disable_send = false;
            console.log(res);
            if (res.st === true) {
                field_data.your_name = "";
                field_data.your_email = "";
                field_data.recipient_name = "";
                field_data.recipient_email = "";
                field_data.gift_amount = "";
                message = "";
                field_data.cc_number = "";
                field_data.cc_name = "";
                field_data.cc_cvc = "";
                field_data.cc_expiry = "";
                resetFieldData()
            } else {
                // address_not_found = true;
                //   alert('TODO: deal with unknown address?');
            }
        }else{
            toast.push("Please fill out all required fields", {
                duration: 5000,
                // initial: 0,
                // progress: 0,
                dismissable: false,
                theme: {
                    '--toastBackground': '#F56565',
                    '--toastProgressBackground': '#C53030'
                }
            });

        }


    }

</script>

<Header />

<div class="formholder">
    <div class="pagetitle">
    Gift Cards
    </div>

    <div class="preformcontent">

    </div>

    <div class="ff yourname">
        <Textfield 
            style="width: 100%;"
            required
            invalid={field_data.your_name_iv}
            helperLine$style="width: 100%;" 
            variant="outlined" 
            bind:value={field_data.your_name}
            label="Your Name"
            on:input={() => {validateSingle('your_name')}}
            on:blur={() => {validateSingle('your_name')}}
        >
            <HelperText validationMsg=true persistent=true slot="helper">{field_data.your_name_h}</HelperText>

        </Textfield>
    </div>

    <div class="ff youremail">
        <Textfield 
            type="email"
            required
            invalid={field_data.your_email_iv}
            style="width: 100%;"
            helperLine$style="width: 100%;" 
            variant="outlined" 
            bind:value={field_data.your_email}
            label="Your Email"
            on:input={() => {validateSingle('your_email')}}
            on:blur={() => {validateSingle('your_email')}}
        >
            <HelperText validationMsg=true persistent=true slot="helper">{field_data.your_email_h}</HelperText>
        </Textfield>            
    </div>

    <div class="ff recipientname">
        <Textfield 
            style="width: 100%;"
            required
            invalid={field_data.recipient_name_iv}
            helperLine$style="width: 100%;" 
            variant="outlined" 
            bind:value={field_data.recipient_name}
            label="Recipient Name"
            on:input={() => {validateSingle('recipient_name')}}
            on:blur={() => {validateSingle('recipient_name')}}
        >
            <HelperText validationMsg=true persistent=true slot="helper">{field_data.recipient_name_h}</HelperText>
        </Textfield>            
    </div>

    <div class="ff recipientemail">
        <Textfield 
            type="email"
            required
            invalid={field_data.recipient_email_iv}
            style="width: 100%;"
            helperLine$style="width: 100%;" 
            variant="outlined" 
            bind:value={field_data.recipient_email}
            label="Recipient Email"
            on:input={() => {validateSingle('recipient_email')}}
            on:blur={() => {validateSingle('recipient_email')}}
        >
            <HelperText validationMsg=true persistent=true slot="helper">{field_data.recipient_email_h}</HelperText>
        </Textfield>            
    </div>

    <div class="ff giftamount">
        <Textfield 
            required
            invalid={field_data.gift_amount_iv}
            style="width: 100%;"
            helperLine$style="width: 100%;" 
            variant="outlined" 
            bind:value={field_data.gift_amount}
            label="Gift Amount"
            on:input={() => {validateSingle('gift_amount')}}
            on:blur={() => {validateSingle('gift_amount')}}
        >
            <Icon class="material-icons" slot="leadingIcon">attach_money</Icon>
            <HelperText validationMsg=true persistent=true slot="helper">{field_data.gift_amount_h}</HelperText>
        </Textfield>            
    </div>

    <div class="ff message">
        <Textfield 
            textarea 
            input$maxlength="1000" 
            style="width: 100%; height: 100%"
            bind:value={message} 
            label="Message"
            on:input={() => {validateSingle('message')}}
            on:blur={() => {validateSingle('message')}}
        >
            <CharacterCounter slot="internalCounter">0 / 1000</CharacterCounter>
        </Textfield>
    </div>

    <div class="ccpreview">
        <CreditCard
            number="{field_data.cc_number}"
            name="{field_data.cc_name}"
            cvc="{field_data.cc_cvc}"
            expiry="{field_data.cc_expiry}"
            preview="{true}"
            focused="{focused_field}"
        />
    </div>

    <div class="ff ccname">
        <Textfield
            required
            invalid={field_data.cc_name_iv}
            style="width: 100%;"
            helperLine$style="width: 100%;" 
            variant="outlined" 
            bind:value={field_data.cc_name}
            label="Card Holder Name"
            on:input={() => {validateSingle('cc_name')}}
            on:blur={() => {validateSingle('cc_name')}}
        >
            <HelperText validationMsg=true persistent=true slot="helper">{field_data.cc_name_h}</HelperText>
        </Textfield>            
    </div>

    <div class="ff ccnumber">
        <Textfield 
            id="cc_number"
            required
            input$pattern="\d+"
            invalid={field_data.cc_name_iv}
            style="width: 100%;"
            helperLine$style="width: 100%;" 
            variant="outlined" 
            bind:value={field_data.cc_number}
            label="Card Number"
            on:input={() => {validateSingle('cc_number')}}
            on:blur={() => {validateSingle('cc_number')}}
        >
            <HelperText validationMsg=true persistent=true slot="helper">{field_data.cc_number_h}</HelperText>
        </Textfield>            
    </div>

    <div class="ff ccexpiry">
        <Textfield 
            required
            invalid={field_data.cc_expiry_iv}
            style="width: 100%;"
            helperLine$style="width: 100%;" 
            variant="outlined" 
            bind:value={field_data.cc_expiry}
            label="Expiration Date"
            on:input={() => {validateSingle('cc_expiry')}}
            on:blur={() => {validateSingle('cc_expiry')}}
        >
            <HelperText validationMsg=true persistent=true slot="helper">Example: MM/YY</HelperText>
        </Textfield>            
    </div>

    <div class="ff cccvc">
        <Textfield 
            required
            input$pattern="\d+"
            invalid={field_data.cc_cvc_iv}
            on:focus={setcvcfocus} 
            on:blur={setnumberfocus}
            style="width: 100%;"
            helperLine$style="width: 100%;" 
            variant="outlined" 
            bind:value={field_data.cc_cvc}
            label="CVC"
            on:input={() => {validateSingle('cc_cvc')}}
            on:blur={() => {validateSingle('cc_cvc')}}
        >
            <HelperText validationMsg=true persistent=true slot="helper">{field_data.cc_cvc_h}</HelperText>
        </Textfield>            
    </div>

    <div class="ff buttonbar">
        <Button 
            disabled = {disable_send}
            on:click={()=>{send_gift_card()}}
            variant="raised" 
            class="button-shaped-round"
        >
            Send Now
        </Button>
    </div>
</div>

<style>
.formholder {
        width: 80%;
        margin-left: auto;
        margin-right: auto;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-template-areas: "pt pt pt pt"
                             "pc pc pc pc"
                             "yn yn ye ye"
                             "rn rn re re"
                             "ga ga .  . "
                             "ms ms ms ms"
                             "cp cp ch ch"
                             "cp cp cn cn"
                             "cp cp ex cv"
                             "bb .  .  . ";
    }

    @media (max-device-width: 1024px), (max-width: 1023px) {
        .formholder {
            width: 90%;
            margin-left: auto;
            margin-right: auto;
            display: grid;
            grid-template-columns: 1fr;
            grid-template-areas: "pt"
                                 "pc"
                                 "yn"
                                 "ye"
                                 "rn"
                                 "re"
                                 "ga"
                                 "ms"
                                 "cp"
                                 "ch"
                                 "cn"
                                 "ex"
                                 "cv"
                                 "bb";
        }

    }

    .pagetitle {
        grid-area: pt;
        border-bottom: solid 1px #E9E9EC;
        font-size: 3rem;
        font-weight: bold;
    }

    .preformcontent {
        grid-area: pc;
        padding: 10px;
    }

    .yourname {
        grid-area: yn;
    }

    .youremail {
        grid-area: ye;
    }

    .recipientname {
        grid-area: rn;
    }

    .recipientemail {
        grid-area: re;
    }

    .giftamount {
        grid-area: ga;
    }

    .message {
        grid-area: ms;
        height: 200px;
    }

    .ccpreview {
        grid-area: cp;
    }

    .ccname {
        grid-area: ch;
    }

    .ccnumber {
        grid-area: cn;
    }

    .ccexpiry {
        grid-area: ex;
    }

    .cccvc {
        grid-area: cv;
    }

    .buttonbar {
        grid-area: bb;
    }

    /* globals */
    .ff {
        padding: 10px;
    }

</style>